
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import PropertyAdvantage from '../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../components/ConversationSection/ConversationSection';
import blogIntroImg from '../../assets/blog/img1.jpg';
import blogImg2 from '../../assets/blog/img2.jpg';
import blogImg3 from '../../assets/blog/img3.jpg';
import blogImg4 from '../../assets/blog/img4.jpg';
import blogImg5 from '../../assets/blog/img5.jpg';
import blogImg6 from '../../assets/blog/img6.jpg';
import blogImg7 from '../../assets/blog/img7.jpg';

// Mock Data - Repeated to simulate enough posts for pagination
const allBlogs = [
    {
        id: 1,
        img: blogImg2,
        tags: "Knowledge base, Property",
        title: "Buying a Property? These Legal & Tax traps can cost you big!"
    },
    {
        id: 2,
        img: blogImg3,
        tags: "Knowledge base",
        title: "Property Renting Vs Owning"
    },
    {
        id: 3,
        img: blogImg4,
        tags: "Knowledge base, Property",
        title: "Farm Plots for Sale in Coimbatore"
    },
    {
        id: 4,
        img: blogImg5,
        tags: "Knowledge base, Real Estate",
        title: "Real Estate brokers in Coimbatore"
    },
    {
        id: 5,
        img: blogImg6,
        tags: "Knowledge base",
        title: "Affordable Plots for sale in Coimbatore"
    },
    {
        id: 6,
        img: blogImg7,
        tags: "Knowledge base, Real Estate",
        title: "Apartments vs Villas"
    },
    // Repeats for Page 2
    {
        id: 7,
        img: blogImg2,
        tags: "Investment, Guide",
        title: "Smart Real Estate Investment Strategies for 2026"
    },
    {
        id: 8,
        img: blogImg3,
        tags: "Market Trends",
        title: "Coimbatore Real Estate Market Analysis"
    },
    {
        id: 9,
        img: blogImg4,
        tags: "Eco Living",
        title: "Sustainable Homes: The Future of Living"
    },
    {
        id: 10,
        img: blogImg5,
        tags: "Legal",
        title: "Understanding RERA Compliance"
    },
    {
        id: 11,
        img: blogImg6,
        tags: "Tips, Buying",
        title: "Checklist Before Booking Your First Flat"
    },
    {
        id: 12,
        img: blogImg7,
        tags: "Design",
        title: "Interior Design Trends for Modern Villas"
    },
    // Repeats for Page 3
    {
        id: 13,
        img: blogImg3,
        tags: "Finance",
        title: "Home Loans Explained: Interest Rates & Eligibility"
    }
];

const Blog = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    // Logic
    const totalPages = Math.ceil(allBlogs.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // Simulate empty state if page > totalPages (for testing "No more blog")
    // or if we simply decide to filter/empty it.
    // For now, standard pagination handles mapping.
    const currentBlogs = allBlogs.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber: number) => {
        if (pageNumber >= 1 && pageNumber <= totalPages + 1) {
            // Allowing +1 to demonstrate "No more blog" state if desired
            setCurrentPage(pageNumber);
        }
    };

    // "No more blogs" Check
    // If user navigates to a page that has no items (e.g. page 4 in this case)
    const isNoBlogsState = currentBlogs.length === 0;

    return (
        <div className="blog-page">
            {/* INTRO ALWAYS VISIBLE */}
            <section className="blogs-intro-section">
                <div className="blogs-intro-container">
                    <div className="blogs-content">
                        <span className="section-tag">Our Blogs</span>
                        <h2 className="blogs-title">
                            Insights & Updates from <br />
                            Jeevan Realty
                        </h2>
                        <p>
                            At Jeevan Realty, we believe that knowledge is the key to making the
                            right property decisions. Our blog is designed to bring you the
                            latest updates, expert tips, and practical guidance on everything
                            related to real estate.
                        </p>
                    </div>
                    <div className="blogs-image">
                        <img src={blogIntroImg} alt="Real Estate Insights Image" />
                    </div>
                </div>
            </section>

            <section className="blogs-section">
                <div className="blogs-container">

                    {/* NO BLOGS STATE */}
                    {isNoBlogsState ? (
                        <div className="no-blogs-container" style={{ gridColumn: "1 / -1" }}>
                            <p className="no-blogs-text">No more blog have been published.</p>
                            <button
                                className="back-home-btn"
                                onClick={() => setCurrentPage(1)}
                            >
                                Back to First Page
                            </button>
                        </div>
                    ) : (
                        // BLOG GRID
                        currentBlogs.map((blog) => (
                            <div className="blog-card" key={blog.id}>
                                <div className="blog-image">
                                    <span className="blog-tag">{blog.tags}</span>
                                    <img src={blog.img} alt="Blog Image" />
                                </div>
                                <div className="blog-content">
                                    <h3>{blog.title}</h3>
                                    <Link to="/blog/details" className="read-more">Read more →</Link>
                                </div>
                            </div>
                        ))
                    )}

                </div>

                {/* PAGINATION CONTROLS */}
                {/* Use totalPages + 1 in logic to allow user to click 'Next' into empty state if that's the requirement */}
                <div className="pagination">

                    {/* LEFT ARROW */}
                    <button
                        className="page-btn"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'default' : 'pointer' }}
                    >
                        &lt;
                    </button>

                    {/* PAGE NUMBERS */}
                    {Array.from({ length: totalPages }).map((_, i) => {
                        const pageNum = i + 1;
                        return (
                            <button
                                key={pageNum}
                                className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                                onClick={() => handlePageChange(pageNum)}
                            >
                                {pageNum}
                            </button>
                        );
                    })}

                    {/* MOCK EXTRA PAGE FOR "NO MORE BLOGS" DEMO (Page 4) */}
                    <button
                        className={`page-btn ${currentPage === totalPages + 1 ? 'active' : ''}`}
                        onClick={() => handlePageChange(totalPages + 1)}
                    >
                        {totalPages + 1}
                    </button>

                    {/* RIGHT ARROW */}
                    <button
                        className="page-btn"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage > totalPages} // Allow going to totalPages + 1
                        style={{ opacity: currentPage > totalPages ? 0.5 : 1, cursor: currentPage > totalPages ? 'default' : 'pointer' }}
                    >
                        &gt;
                    </button>



                </div>
            </section>


            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default Blog;


